import { authRequest } from './client';
import { type PlatformWalletsResponse } from './types';

// Task 28 Part A: `services/backoffice-api/src/platform-wallets/` mirrored
// exactly — a single, unpaginated FINANCE_VIEWER-gated read.

export function getPlatformWallets(): Promise<PlatformWalletsResponse> {
  return authRequest<PlatformWalletsResponse>('/platform-wallets');
}
